import { useEffect } from "react";
import { ScrollArea } from "../ui/scroll-area";
import { Link } from "react-router-dom";
import ModalContainer from ".";

type Props = {
  open: boolean;
  close: () => void;
  url: string;
};

const InterviewModal = ({ open, close, url }: Props) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") close?.();
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);
  
  if (!open) return null;

  return (
    <div className="w-full">
      <ModalContainer open={open} close={close}>
        <ScrollArea>
          <div className="flex items-center justify-center w-[90vw] h-[55vh] md:w-[55vw] md:h-[65vh]">
            {url ? (
              <iframe
                src={url}
                allow="autoplay"
                className="w-[90vw] h-[45vh] md:w-[50vw] md:h-[55vh] place-self-center self-center"
              />
            ) : (
              <p>No data currently</p>
            )}
          </div>
        </ScrollArea>
      </ModalContainer>
    </div>
  );
};

export default InterviewModal;
